export * from './kopieren-post-request.interface';
export * from './kopieren-post-response.interface';
export * from './kopieren-post.shapes';
